module.exports = __webpack_public_path__ + "guide-step-arrow.3786d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/guide-step-arrow.svg
// module id = ./src/_asset/sources/assets/images/@svg/guide-step-arrow.svg
// module chunks = main